import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
import PropTypes from "prop-types";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";


// core components
import Button from "components/CustomButtons/Button.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";

import heroCardStyle from "assets/jss/material-kit-react/components/heroCardStyle.jsx"

import aircraft from "assets/img/aircraft.svg";
import ballot from "assets/img/ballot.svg";
import coinTree from "assets/img/coin-tree.svg";
import column from "assets/img/column.svg";
import compassRose from "assets/img/compass-rose.svg";
import diamond from "assets/img/diamond.svg";
import document from "assets/img/document.svg";
import fourHands from "assets/img/four-hands.svg";
import genderEquality from "assets/img/gender-equality.svg";
import handshake from "assets/img/handshake.svg";
import hardHat from "assets/img/hard-hat.svg";
import heartInCuppedHands from "assets/img/heart-in-cupped-hands.svg";
import humaneTechnology from "assets/img/humane-technology.svg";
import ingots from "assets/img/ingots.svg";
import key from "assets/img/key.svg";
import loudspeaker from "assets/img/loudspeaker.svg";
import magicWand from "assets/img/magic-wand.svg";
import magnifyingGlass from "assets/img/magnifying-glass.svg";
import medicine from "assets/img/medicine.svg";
import microscope from "assets/img/microscope.svg";
import pearl from "assets/img/pearl.svg";
import pentagonChart from "assets/img/pentagon-chart.svg";
import plantInHand from "assets/img/plant-in-hand.svg";
import pointingHand from "assets/img/pointing-hand.svg";
import racialEquity from "assets/img/racial-equity.svg";
import rainbowFlag from "assets/img/rainbow-flag.svg";
import redCross from "assets/img/red-cross.svg";
import scales from "assets/img/scales.svg";
import scroll from "assets/img/scroll.svg";
import select from "assets/img/select.svg";
import shieldLock from "assets/img/shield-lock.svg";
import signpost from "assets/img/signpost.svg";
import threeHands from "assets/img/three-hands.svg";
import threeSpeechBubbles from "assets/img/three-speech-bubbles.svg";
import threeWomen from "assets/img/three-women.svg";
import torch from "assets/img/torch.svg";
import twoHands from "assets/img/two-hands.svg";
import twoSpeechBubbles from "assets/img/two-speech-bubbles.svg";
import vennDiagram from "assets/img/venn-diagram.svg";
import vote from "assets/img/vote.svg";
import windmill from "assets/img/windmill.svg";

const flatIcons = {
  aircraft,
  ballot,
  coinTree,
  column,
  compassRose,
  diamond,
  document,
  fourHands,
  genderEquality,
  handshake,
  hardHat,
  heartInCuppedHands,
  humaneTechnology,
  ingots,
  key,
  loudspeaker,
  magicWand,
  magnifyingGlass,
  medicine,
  microscope,
  pearl,
  pentagonChart,
  plantInHand,
  pointingHand,
  racialEquity,
  rainbowFlag,
  redCross,
  scales,
  scroll,
  select,
  shieldLock,
  signpost,
  torch,
  threeHands,
  threeSpeechBubbles,
  threeWomen,
  twoHands,
  twoSpeechBubbles,
  vennDiagram,
  vote,
  windmill
};

function mapBodyTypes(props) {
  const {
    classes,
    hero
  } = props;

  if (hero.body) {
    return hero.body.map((bodySection) => {
      switch (bodySection.type) {
        case "text":
          return (
            <p dangerouslySetInnerHTML={{__html: `${bodySection.text}`}}/>
          )
        case "feature":
      // "img": {
      //   "src": "/assets/img/compass-rose.svg",
      //   "alt": "A compass rose."
      // }
          return (
            <GridContainer justify="space-between" className={classes.feature}>
            <GridItem xs={3} sm={2}  style={{
              padding: "10px"
            }}>
              <img src={flatIcons[bodySection.img.image]} alt={bodySection.img.alt} className={classes.featureImage}/>
            </GridItem>
            <GridItem className={classes.featureBody} xs={9} sm={10}>
                  <h4 className={classes.featureTitle}>{bodySection.title}</h4>
                  <h5 className={classes.featureSubtitle}>{bodySection.subtitle}
                  </h5>
            </GridItem>
            </GridContainer>
          )
        default:
          return null;
      }
    });
  } else if (hero.text) {
    if (!Array.isArray(hero.text)) {
      return (
        <p dangerouslySetInnerHTML={{__html: `${hero.text}`}}/>
      )
    } else {
      return hero.text.map(line => {
        return (
          <p className={classes.text} dangerouslySetInnerHTML={{__html: `${line}`}}/>
          )
      });
    }
  } else {
    return (
      <p>{hero.text}</p>
    )
  }

  return null;
}

function mapLearnMore (props) {
  const {
    classes,
    hero
  } = props;

  if (hero.learnMore) {
    if (typeof hero.learnMore === 'string' || hero.learnMore instanceof String) {
      return (
        <span className={classes.learnMore} dangerouslySetInnerHTML={{__html: `${hero.learnMore}`}}/>
      )
    } else {
      return (
        <p className={classes.text}>{hero.learnMore.leadingText}&nbsp;<a href={hero.learnMore.href}>{hero.learnMore.text}</a></p>
      )
    }
  } else {
    return null;
  }
}

function mapButton (props) {
  const {
    classes,
    hero
  } = props;

  if (hero.button) {
    if (typeof hero.button === 'string' || hero.button instanceof String) {
      return (
        <Button className={classes.button} dangerouslySetInnerHTML={{__html: `${hero.learnMore}`}}/>
      )
    } else {
      return (
        <Button className={classes.button} href={hero.button.href} color="rose" fullWidth>{hero.button.text}</Button>
      )
    }
  } else {
    return null;
  }
}

class HeroCard extends React.Component {
  render() {
  const {
    className,
    classes,
    hero
  } = this.props;
  return (
    <div id={hero.id ? hero.id : ""} className={className + " " + classes.containerParent} style={{}}>
      <div className={classes.container}>
        <GridContainer>
          <GridItem className={classes.gridContainerItem} xs={12}>
            <h2 className={classes.title}>
              {!Array.isArray(hero.title) ? <span className={classes.inlineBlock} dangerouslySetInnerHTML={{__html: `${hero.title}`}}/> : hero.title.map(chunk => {
                return (
                  <span className={classes.inlineBlock} dangerouslySetInnerHTML={{__html: `${chunk + '&nbsp'}`}}/>
                )
              })}
            </h2>
          </GridItem>
          </GridContainer>
          <GridContainer>
          <GridItem className={classes.gridContainerItem2} xs={10} >
            <h2 className={classes.subtitle}>
              <small style={{lineHeight: "1.5em"}}>
                {!Array.isArray(hero.subtitle) ? hero.subtitle : hero.subtitle.map(chunk => {
                  return (
                    <span className={classes.inlineBlock} dangerouslySetInnerHTML={{__html: `${chunk + '&nbsp'}`}}/>
                  )
                })}
              </small> 
            </h2>
          </GridItem>
          <GridItem className={classes.gridContainerItem2} xs={11} >
            {mapBodyTypes(this.props)}
            {mapLearnMore(this.props)}
            {mapButton(this.props)}
          </GridItem>
          <GridItem className={classes.gridContainerItem2} xs={11} >
            {hero.footnotes ? hero.footnotes.map((footnote) => (
              <p className={classes.footnote} dangerouslySetInnerHTML={{__html: `${footnote}`}}/>
            )) 
            : ""}
          </GridItem>
        </GridContainer>
      </div>
    </div>
  )}
}

HeroCard.defaultProp = {

};

HeroCard.propTypes = {
  hero: PropTypes.object.isRequired
};

export default withStyles(heroCardStyle)(HeroCard);